import type { ButtonProps } from "@overmap-ai/blocks"
import { IconButton, Layout, LuIcon } from "@overmap-ai/blocks"
import { forwardRef, memo } from "react"

import { SLIDE_OUT_IDS } from "../../layouts"
import { modelIconMapping } from "../../mappings/icons"

export const AIButton = memo(
	forwardRef<HTMLButtonElement, Omit<ButtonProps, "children">>((props, ref) => {
		return (
			<Layout.SlideOutTrigger slideOutId={SLIDE_OUT_IDS.AI}>
				<IconButton ref={ref} aria-label="ai chat" variant="surface" accentColor="primary" {...props}>
					<LuIcon icon={modelIconMapping.ai} />
				</IconButton>
			</Layout.SlideOutTrigger>
		)
	}),
)
AIButton.displayName = "AIButton"
